import {getType} from "typesafe-actions"
import update from "immutability-helper"
import {
    CoreActions,
    getDatabaseSuccessAction,
    getUserSuccessAction,
    getShowDisclaimerSuccessAction,
    saveTermsSuccessAction,
    getRolesSuccessAction,
} from "../actions/core.actions"

export interface State {
    user: {
        internOnly: boolean
        showDisclaimer: boolean
        roles: string[]
    }
    database: string
}

const initialState = {
    user: {internOnly: undefined, showDisclaimer: undefined, roles: []},
    database: undefined,
}

export default function (
    state: State = initialState,
    action: CoreActions
): State {
    switch (action.type) {
        case getType(getDatabaseSuccessAction): {
            return update(state, {database: {$set: action.payload}})
        }
        case getType(getUserSuccessAction): {
            return update(state, {user: {internOnly: {$set: action.payload}}})
        }
        case getType(getRolesSuccessAction): {
            return update(state, {user: {roles: {$set: action.payload}}})
        }
        case getType(getShowDisclaimerSuccessAction): {
            return update(state, {
                user: {showDisclaimer: {$set: action.payload}},
            })
        }
        case getType(saveTermsSuccessAction): {
            return update(state, {
                user: {showDisclaimer: {$set: false}},
            })
        }
        default:
            return state
    }
}
